import * as React from 'react';
import { FeatureFlagsContext } from '../components/FeatureFlagsProvider/FeatureFlagsProvider';
import { defaultFeatureFlags } from '../utils/feature-flags';

export function useFeatureFlags(flag: keyof typeof defaultFeatureFlags) {
  const flags = React.useContext(FeatureFlagsContext);

  return flags[flag];
}
